import { isEmpty } from 'lodash';
import checkIsVariantEnabled from './checkIsVariantEnabled';

export default function getSelectedVariants(productVariants, formVariants) {
  if (!productVariants || !productVariants.length) return [];
  if (!formVariants || isEmpty(formVariants)) return [];

  const variants = Object.keys(formVariants)
    .map(variantId => {
      const variant = productVariants.find(v => v._id === variantId);

      if (!variant) return null;

      // if quantity select is enabled, we loop through each selected option and store as selectedOptions
      if (variant.selectionType === 'quantity') {
        const selectedOptions = formVariants[variantId];

        if (!selectedOptions || !selectedOptions.length) return null;

        const visible = checkIsVariantEnabled(variant, formVariants, productVariants);

        if (!visible) {
          return null;
        }

        variant.selectedOptions = variant.options
          .filter(o => selectedOptions.find(so => so.optionId === o._id))
          .map(o => {
            const selectedOption = selectedOptions.find(so => so.optionId === o._id);

            return {
              ...o,
              quantity: selectedOption.quantity,
            };
          });

        return variant;
      } else if (variant.selectionType === 'multiple') {
        const selectedOptions = formVariants[variantId];

        if (!selectedOptions || !selectedOptions.length) return null;

        const visible = checkIsVariantEnabled(variant, formVariants, productVariants);

        if (!visible) {
          return null;
        }

        variant.selectedOptions = variant.options
          .filter(o => selectedOptions.find(so => so.optionId === o._id))
          .map(o => {
            const selectedOption = selectedOptions.find(so => so.optionId === o._id);

            return {
              ...o,
              quantity: selectedOption.quantity,
            };
          });

        return variant;
      } else if (variant.selectionType === 'single') {
        const selectedOption = formVariants[variantId][0];

        if (!selectedOption) return null;

        const visible = checkIsVariantEnabled(variant, formVariants, productVariants);

        if (!visible) {
          return null;
        }

        variant.selectedOption = variant.options?.find(o => o._id === selectedOption.optionId);

        return variant;
      }
    })
    .filter(Boolean);

  return variants;
}
